<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="langType? '发货' : 'Deliver'"
    :visible.sync="visible"
    width="400px"
    class="remarkDialog"
    :before-close="handleClose"
  >
    <el-form :model="form" ref="form" label-width="108px">
      <el-form-item   :label="langType ? '订单编号：' : 'Order No：'">
        {{ this.orderData.appNo }}
      </el-form-item>
      <el-form-item   :label="langType ? '商家账号：' : 'Account：'" >
        {{ this.orderData.operNo }}
      </el-form-item>
      <el-form-item  :label="langType ? '物流名称：' : 'Logistics：'" prop="shippingMethodName" >
        <el-input
          :disabled="isReadOnly"
          v-model="form.shippingMethodName"
          class="input"
          size="small"
        />
      </el-form-item>

      <el-form-item  :label="langType ? '运单号：' : 'Tracking No：'" prop="trackingNumber">
        <el-input
          :disabled="isReadOnly"
          v-model="form.trackingNumber"
          class="input"
          size="small"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">{{ langType? "取消" : "Cancel" }}</el-button>
      <el-button type="primary" @click="sure" size="small"> {{ langType? "确定" : "Confirm" }} </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { sendPhByHand } from "@/api/order/all"

export default {
  name: "SendOrderFlb",
  data() {
    return {
      form: {
        shippingMethod: "",
        shippingMethodName: "",
        appId: "",
        trackingNumber: "",
      },
      isReadOnly: false,

      rules: {
        shippingMethodName: [
          { required: true, message: "请输入物流名称", trigger: "blur" },
        ],
        trackingNumber: [
          { required: true, message: "请输入运单号", trigger: "blur" },
        ],
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
    langType: {
      type: Boolean,
      default() {
        return true
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          shippingMethod: "",
          shippingMethodName: "",
          appId: "",
          trackingNumber: "",
        }
        if (this.orderData.expreList && this.orderData.expreList.length > 0) {
          this.form.shippingMethod = this.orderData.expreList[0].shippingMethod
          this.form.shippingMethodName = this.orderData.expreList[0].shippingMethodName
        }
        //
        if (
          this.orderData.orderSource == "01" ||
          this.orderData.orderSource == "02"
        ) {
          this.form.shippingMethod = this.orderData.skuList[0].shippingProvider
          this.form.shippingMethodName = this.orderData.skuList[0].shippingProvider
          this.form.trackingNumber = this.orderData.skuList[0].trackingCode
          this.isReadOnly = true
        }
      }
    },
  },
  methods: {
    sure() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.appId = this.orderData.appId
          this.startLoading()
          sendPhByHand(this.form)
            .then((response) => {
              if (response.code == "200") {
                this.msgSuccess(response.msg)
                window.setTimeout(() => {
                  this.endLoading()
                  this.$emit("onClose", this.form)
                }, 3000)
              } else {
                this.endLoading()
                this.$emit("onClose", this.form)
              }
            })
            .catch(() => {
              this.endLoading()
            })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.color {
  padding: 1px;
  margin: 3px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #eee;
}

.color.active {
  border: 1px solid #333;
}

.color-inner {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
